import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import bgImage from "assets/img/background-login.jpg";
import logoImage from "assets/img/dummy-logo.png";
import configData from "../../../src/config.json";
import Cookies from "universal-cookie";
import { Spinner } from 'reactstrap';
import { toast, ToastContainer } from "react-toastify";
import { setCookie, getCookie, removeCookie } from "_helper";
import Firebase from '../../firebase';
function Login() {
  const [login, setLogin] = useState({
    UserName: "",
    Password: "",
  });
  const history = useHistory();
  const cookies = new Cookies();
  const [loginspinner, setloginspinner] = useState(false);
  const [checked, setChecked] = useState(false);
  const [FireBaseTokendata, setFireBaseTokendata] = useState("")
let mydata = ""
  const onInputChange = (e) => {
    setLogin({ ...login, [e.target.name]: e.target.value });
  };
console.log(login);
  const bindHeader = () => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Access-Control-Allow-Origin", configData.API_URL);
    headers.append("Access-Control-Allow-Credentials", "true");
    return headers;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setloginspinner(true)
    const msg = Firebase.messaging();
    msg.requestPermission().then(() => {
      return msg.getToken();
    }).then((data) => {
      console.log("token", data);
      let mydata ={
        ...login,
        FireBaseToken:data
        }
      console.log(data)
      var headers = bindHeader();
      console.log(mydata)
       fetch(`${configData.API_URL}/api/login`, {
        method: "POST",
        body: JSON.stringify(mydata),
        headers: headers,
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            var user = res.data[0];
            if (user.RoleId != 1 && user.RoleId != 3) {
  
              alert("You do not have permission to access this portal!!!");
            } else {
              localStorage.setItem("roleid", user.RoleId)
              cookies.set("token", user.AuthKey);
              cookies.set("device", user.DeviceId);
              if (checked == true) {
                setCookie(process.env.REACT_APP_CRYPTO_SECRET_REMEMBER, 'yes')
                setCookie(process.env.REACT_APP_CRYPTO_SECRET_EMAIL, login.UserName)
                setCookie(process.env.REACT_APP_CRYPTO_SECRET_PASSWORD, login.Password)
              }
              else {
                setCookie('remember', 'no')
                removeCookie(process.env.REACT_APP_CRYPTO_SECRET_EMAIL)
                removeCookie(process.env.REACT_APP_CRYPTO_SECRET_PASSWORD)
              }
              history.push("/admin");
              setTimeout(() => {
                setloginspinner(false)
              }, 2000);
            }
          } else {
            toast.error(res.message);
            setloginspinner(false)
          }
        });
        
      
      
    }).catch(err => {
      console.log(err);
    })
   
   
 
   
     
  };



  useEffect(() => {

    var emaildata = ''
    var passworddata = ''
    if (getCookie(process.env.REACT_APP_CRYPTO_SECRET_REMEMBER) == 'yes') {
      setChecked(true)
      emaildata = getCookie(process.env.REACT_APP_CRYPTO_SECRET_EMAIL);
      passworddata = getCookie(process.env.REACT_APP_CRYPTO_SECRET_PASSWORD);
    }
    setLogin({
      UserName: emaildata,
      Password: passworddata
    })
  }, [])



  return (
    <div>
      <ToastContainer />
      <div class="wrapper wrapper-full-page">
        <div class="full-page section-image" filter-color="blue">
          <div class="content">
            <div class="login-page">
              <div class="container">
                <div class="ml-auto mr-auto col-12 col-md-8 col-lg-4">
                  <form class="">
                    <div class="card-login card-plain card">
                      <div class="card-header">
                        <div class="logo-container">
                          <img src={logoImage} />
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="no-border form-control-lg  input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <i class="now-ui-icons users_circle-08"></i>
                            </span>
                          </div>
                          <input
                            name="UserName"
                            placeholder="Username"
                            type="email"
                            class="form-control"
                            onChange={(e) => onInputChange(e)}
                            value={login.UserName}

                          />
                        </div>
                        <div class="no-border form-control-lg  input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <i class="now-ui-icons text_caps-small"></i>
                            </span>
                          </div>
                          <input
                            name="Password"
                            placeholder="Password"
                            type="password"
                            class="form-control"
                            onChange={(e) => onInputChange(e)}
                            value={login.Password}
                          />
                        </div>
                        <div className="mt-4 text-center">
                          <input type="checkbox" id="remeberme" name="remeberme" onChange={() => setChecked(!checked)}
                            checked={checked}
                          />
                          <label className="ml-2"> Remember Me</label>

                        </div>
                      </div>

                      <div class="card-footer">
                        <button
                          type="button"
                          class="mb-3 btn-round btn btn-primary btn-lg btn-block"
                          onClick={(e) => submitHandler(e)}
                        >

                          {loginspinner ? <> Loading <Spinner color="gray" size="sm" className="ml-2" />  </> : "Get Started"}
                        </button>
                        <div class="pull-right">
                          <h6>
                            <Link
                              to="/register"
                              class="link footer-link"

                            >
                              Create Account
                            </Link>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div
            class="full-page-background"
            style={{
              backgroundImage: `url('${bgImage}')`,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
export default Login;
